var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 63,
    viewBox: "0 0 49 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_267_17552)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 36,
    height: 51,
    fill: "#130D38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.875 0H9.125C6.29557 0 4 2.30957 4 5.15625V49.8438C4 52.6904 6.29557 55 9.125 55H39.875C42.7044 55 45 52.6904 45 49.8438V5.15625C45 2.30957 42.7044 0 39.875 0ZM19.375 3.4375H29.625C30.5646 3.4375 31.3333 4.21094 31.3333 5.15625C31.3333 6.10156 30.5646 6.875 29.625 6.875H19.375C18.4354 6.875 17.6667 6.10156 17.6667 5.15625C17.6667 4.21094 18.4354 3.4375 19.375 3.4375ZM24.5 17.1875C28.269 17.1875 31.3333 20.2705 31.3333 24.0625C31.3333 27.8545 28.269 30.9375 24.5 30.9375C20.731 30.9375 17.6667 27.8545 17.6667 24.0625C17.6667 20.2705 20.731 17.1875 24.5 17.1875ZM36.4583 42.625C36.4583 43.7637 35.3906 44.6875 34.0667 44.6875H14.9333C13.6094 44.6875 12.5417 43.7637 12.5417 42.625V40.5625C12.5417 37.1465 15.7555 34.375 19.7167 34.375H20.2505C21.5638 34.9229 22.9945 35.2344 24.5 35.2344C26.0055 35.2344 27.4469 34.9229 28.7495 34.375H29.2833C33.2445 34.375 36.4583 37.1465 36.4583 40.5625V42.625Z",
    fill: "#E7E7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_267_17552",
    x: 0,
    y: 0,
    width: 49,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_267_17552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_267_17552",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCallIcon);
export default __webpack_public_path__ + "static/media/active-call-icon.d5356e7cc55d4113a26fab4cf93fc1e8.svg";
export { ForwardRef as ReactComponent };